// extracted by mini-css-extract-plugin
export var closeButton = "_bo-1";
export var closeX = "_bo-3";
export var container = "_bo-0";
export var image = "_bo-2";